import { combineReducers } from '@reduxjs/toolkit'
import list from './list.store'
import status from './status.store'

export const rootReducer = combineReducers({
  list,
  status,
})
